import { useRouter } from 'next/router';
import { useContext } from 'react';
import { KaimonoWebRoutes } from 'src/config/routes';
import { useCartQuantity } from 'src/hooks/useCartQuantity';
import { I18nContext } from 'src/stores/I18n';
import { ShopsContext } from 'src/stores/Shops';
import { setShopId } from 'src/utils/cookies';
import { mixpanel } from 'src/utils/mixpanel';
import { toJSX } from 'src/utils/toJSXHelper';
import { useCart } from './useCart';
import { useCurrentShop } from './useCurrentShop';
import { useModal } from './useModal';

export const useShopSelector = () => {
  const shops = useContext(ShopsContext);
  const { shopId, currentShop, setCurrentShop } = useCurrentShop();
  const { setIsVisible, setModalParams } = useModal('noticeModal');
  const { removeCart } = useCart();
  const { mutate: mutateCartQuantity } = useCartQuantity();
  const localeResources = useContext(I18nContext);
  const router = useRouter();

  const changeShopHandler = async (id: number, ignitionSource: string, notResetCart: boolean = false) => {
    setShopId(String(id));
    const selectedShop = shops.find((shop) => shop.id === id);
    setCurrentShop(selectedShop);
    // notResetCartがtrueの場合はカートをリセットせず、空港を変更するだけ
    if (!notResetCart) {
      await removeCart();
      mutateCartQuantity();
    }
    shopId.set(id);
    const shop = shops.find((shop) => shop.id === id);
    setModalParams({
      type: 'info',
      title: localeResources.airports.airportSwitched,
      text: shop?.name,
      textPink: true,
      extraData: {
        customElement: shop?.pickupType === 'counter' ? toJSX(localeResources.receive.vjwRegistrationInfo) : null
      }
    });
    setIsVisible(true);
    mixpanel.onShopSelect(shops.find((shop) => shop.id === id)!.slug, ignitionSource);
    if (router.pathname === KaimonoWebRoutes.order.new) {
      router.push(KaimonoWebRoutes.index);
    }
  };

  return {
    currentShop,
    setCurrentShop,
    changeShopHandler
  };
};
